'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Configuration'];
module.exports = angular.module('AVRO.Common.Formatting', dependencies).value('FormattingConstants', require('./constants/FormattingConstants')).run(require('./config/I18nConfig')).filter('rmNumberFormat', require('./filters/NumberFormattingFilter')).filter('rmCut', require('./filters/CutFilter')).filter('rmPercent', require('./filters/PercentFilter'));